<template>
  <span>
    <div id="loading-bg">
      <div class="loading-logo">
        <img
          :src="appLogoImageUrl"
          alt="Logo"
        >
      </div>
      <div class="loading">
        <div class="effect-1 effects" />
        <div class="effect-2 effects" />
        <div class="effect-3 effects" />
      </div>
    </div>
    <div
      class="h-100"
      :class="[skinClasses]"
    >
      <div :class="{'pb-2': !isFullLayout}">
        <component :is="layout">
          <router-view :key="$route.path" />
        </component>
      </div>
    </div>
  </span>
</template>

<script>

// This will be populated in `beforeCreate` hook
import { $themeColors, $themeBreakpoints, $themeConfig } from '@themeConfig'
import { watch } from '@vue/composition-api'
import useAppConfig from '@core/app-config/useAppConfig'

import { useWindowSize, useCssVar } from '@vueuse/core'

import store from '@/store'
import authService from '@/vue.auth.service'

const LayoutVertical = () => import('@core/layouts/layout-vertical/LayoutVertical.vue')
const LayoutFull = () => import('@core/layouts/layout-full/LayoutFull.vue')

export default {
  metaInfo: {
    link: [{ rel: 'icon', href: `/favicon-${$themeConfig.app.appDir}.ico` }],
    title: `${$themeConfig.app.appName} - ${$themeConfig.app.appTitle}`,
    titleTemplate: null, // all titles will be injected into this template
  },
  components: {

    // Layouts
    LayoutVertical,
    LayoutFull,

  },

  data() {
    return {
      timer: null,
    }
  },
  // ! We can move this computed: layout & contentLayoutType once we get to use Vue 3
  // Currently, router.currentRoute is not reactive and doesn't trigger any change
  computed: {
    isFullLayout() {
      return (this.$route.meta.layout === 'full')
    },
    layout() {
      if (this.isFullLayout) return 'layout-full'
      return `layout-${this.contentLayoutType}`
    },
    contentLayoutType() {
      return this.$store.state.appConfig.layout.type
    },
  },
  mounted() {
    this.timer = setInterval(this.tick, 60 * 1000) // every 1 minute
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  beforeCreate() {
    // Set colors in theme
    const colors = ['primary', 'secondary', 'success', 'info', 'warning', 'danger', 'light', 'dark']

    // eslint-disable-next-line no-plusplus
    for (let i = 0, len = colors.length; i < len; i++) {
      $themeColors[colors[i]] = useCssVar(`--${colors[i]}`, document.documentElement).value.trim()
    }

    // Set Theme Breakpoints
    const breakpoints = ['xs', 'sm', 'md', 'lg', 'xl']

    // eslint-disable-next-line no-plusplus
    for (let i = 0, len = breakpoints.length; i < len; i++) {
      $themeBreakpoints[breakpoints[i]] = Number(useCssVar(`--breakpoint-${breakpoints[i]}`, document.documentElement).value.slice(0, -2))
    }

    // Set RTL
    const { isRTL } = $themeConfig.layout
    document.documentElement.setAttribute('dir', isRTL ? 'rtl' : 'ltr')
  },
  methods: {
    async tick() {
      authService.checkTimeoutSession()
    },
  },
  setup() {
    const { skin, skinClasses } = useAppConfig()
    const { appLogoImageUrl } = $themeConfig.app

    // If skin is dark when initialized => Add class to body
    if (skin.value === 'dark') document.body.classList.add('dark-layout')

    // Set Window Width in store
    store.commit('app/UPDATE_WINDOW_WIDTH', window.innerWidth)
    const { width: windowWidth } = useWindowSize()
    watch(windowWidth, val => {
      store.commit('app/UPDATE_WINDOW_WIDTH', val)
    })

    return {
      skinClasses,
      appLogoImageUrl,
    }
  },
}
</script>
